import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

type TruncateLongStringProps = {
  maxWidth?: string;
  className?: string;
};

const TruncateStringContent = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const TruncateString: FunctionComponent<TruncateLongStringProps> = ({
  maxWidth = '325px',
  children,
  className = '',
}) => {
  return (
    <div className={className} style={{ maxWidth }}>
      <TruncateStringContent>{children}</TruncateStringContent>
    </div>
  );
};

export default TruncateString;
